import { render, staticRenderFns } from "./AdminButtons.vue?vue&type=template&id=3d239473&scoped=true&"
import script from "./AdminButtons.vue?vue&type=script&lang=js&"
export * from "./AdminButtons.vue?vue&type=script&lang=js&"
import style0 from "./AdminButtons.vue?vue&type=style&index=0&id=3d239473&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d239473",
  null
  
)

export default component.exports